import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Input from "components/Input";
import Button from "components/Button";
import PhoneNumberInput from "components/PhoneNumberInput";
import TextDivider from "components/TextDivider";
import useAuth from "customHook/useAuth";
import { Container, ContentContainer } from "./styles";
import { HiddenIcon, VisibleIcon } from "assets/icons";
import Logo from "assets/Logo.png";

const Login = () => {

  const [loginByPhone, setLoginByPhone] = useState(false);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberValidity, setPhoneNumberValidity] = useState(true);
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [passwordHidden, setPasswordHidden] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const { userLogin, loginLoading } = useAuth();

  const login = () => {
    if (loginLoading) return;
    if(passwordError) return;
    if(password.length === 0) {
      setPasswordError(true);
      setErrorMessage("This is required field.");
      return
    }
    if(password.length < 8) {
      setPasswordError(true);
      setErrorMessage("Password must contain at least 8 characters.");
      return
    }
    if(!loginByPhone && /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(email) === false) {
      setEmailError(true);
      return
    }
    if(loginByPhone && (!phoneNumberValidity || phoneNumber.length === 0)) {
      setPhoneNumberError(true);
      return
    }
    if (loginByPhone) {
      userLogin(phoneNumber, password, setPasswordError, setErrorMessage);
    } else {
      userLogin(email, password, setPasswordError, setErrorMessage);
    }
  };

  return (
    <Container>
      <Helmet>
        <title>Login - Rook Hotel PMS</title>
        <meta name="description" content="Login - Rook Hotel PMS" />
      </Helmet>
      <ContentContainer>
        <img src={Logo} alt="Logo" />
        <div className="brand">
          <span className="rook">ROOK </span>
          <span className="hotel">HOTEL</span>
        </div>
        {loginByPhone ? (
          <PhoneNumberInput
            mainPage
            title="PHONE NUMBER"
            titlePosition="center"
            required
            error={phoneNumberError}
            value={phoneNumber}
            onChangeNumber={(number) => {
              setPhoneNumber(number)
              setPhoneNumberError(false)
            }}
            onPhoneValidityChange={setPhoneNumberValidity}
            onBlur={() => {          
              setPhoneNumberError(!phoneNumberValidity && phoneNumber.length > 0);
            }}
            additionalstyle={`
            width: 100%;
            margin-top: 24px;
          `}
          />
        ) : (
          <Input
            mainPage
            title="EMAIL ADDRESS"
            titlePosition="center"
            required
            error={emailError}
            errorMessage={"Please enter a valid email address."}
            onChange={(e) => {
              setEmail(e.target.value)
              setEmailError(false);
            }}
            additionalstyle={`
            width: 100%;
            margin-top: 24px;
          `}
          />
        )}
        <div className="password">
          <Input
            mainPage
            title="PASSWORD"
            titlePosition="center"
            required
            error={passwordError}
            errorMessage={errorMessage}
            onChange={(e) => {
              setPassword(e.target.value)
              setPasswordError(false);
            }}
            type={passwordHidden ? "password" : "text"}
            additionalstyle={`
              width: 100%;
              margin-top: 24px;
            `}
          />
          {passwordHidden ? (
            <div
              className="passwordLock"
              onClick={() => {
                setPasswordHidden(false);
              }}
            >
              <HiddenIcon />
            </div>
          ) : (
            <div
              className="passwordUnlock"
              onClick={() => {
                setPasswordHidden(true);
              }}
            >
              <VisibleIcon />
            </div>
          )}
        </div>
        <Link
          className="highlight"
          to={`/forgot-password`}
          aria-label="redirect to forgot password page"
        >
          Can’t remember your password?
        </Link>
        <Button
          mainPage
          onClick={login}
          data-loading={loginLoading}
          additionalstyle={`
            width: 76px;
            margin-top: 24px;
          `}
        >
          {loginLoading ? null : "Log In"}
        </Button>
        <TextDivider
          text="or"
          additionalstyle={`
            margin-top: 24px;
          `}
        />
        {loginByPhone ? (
          <div
            className="highlight"
            onClick={() => {
              setLoginByPhone(false)
              setEmailError(false);
              setPasswordError(false);
              setPhoneNumberError(false);
              setErrorMessage("");
              setEmail("");
              setPassword("");
              setPhoneNumber("");
            }}
          >
            Log in with email address
          </div>
        ) : (
          <div
            className="highlight"
            onClick={() => {
              setLoginByPhone(true)
              setEmailError(false);
              setPasswordError(false);
              setPhoneNumberError(false);
              setErrorMessage("");
              setEmail("");
              setPassword("");
              setPhoneNumber("");
            }}
          >
            Log in with phone number
          </div>
        )}
      </ContentContainer>
    </Container>
  );
};

export default Login;
